const state = {
  currentWX: {},
  currentWXGroup: {},
  currentWXTags: [],
  onlineWxUser: [],
};

const mutations = {
  // 当前登录微信
  setCurrentWx(state, payload = {}) {
    state.currentWX = payload;
  },
  // 当前微信群
  setCurrentWXGroup(state, payload = {}) {
    state.currentWXGroup = payload;
  },
  // 当前登录微信 群组标签
  setCurrentWXTags(state, payload = []) {
    state.currentWXTags = payload;
  },
  // 所有在线用户
  setOnlineWxUser(state, payload = []) {
    state.onlineWxUser = payload;
  },
};

const getters = {
  todoCurrentWXTags(state) {
    return state.currentWXTags.map((item) => ({
      text: item.tagName,
      label: item.id,
    }));
  },
  todoOnlineWxUser(state) {
    return state.onlineWxUser;
  },
};

export default {
  state,
  mutations,
  getters,
};
